import React from "react";
import ReduxContainer from "./ReduxContainer";
import './App.css'

function App() {
  return (
      <ReduxContainer/>
  );
}
export default App;